import { GetStaticProps } from 'next'
import { NEWS_ACTIVE } from 'src/consts/env'
import { NewsArticles } from 'src/pages/NewsArticles'
import { combineFallbacks } from 'src/state'
import { useNewsArticlesInfinite } from 'src/state/newsArticle'

export default NewsArticles

export const getStaticProps: GetStaticProps = async () => {
  if (!NEWS_ACTIVE) return { notFound: true }

  const fallback = await combineFallbacks(
    useNewsArticlesInfinite.getFallback({})
  )

  return {
    props: { fallback },
    revalidate: 10 * 60,
  }
}
